/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MitarbeiterDto } from '../../models/mitarbeiter-dto';

export interface SetMitarbeiterInactive$Plain$Params {

/**
 * ID des Mitarbeiters der inaktiv gesetzt werden soll
 */
  mitarbeiterId: string;
}

export function setMitarbeiterInactive$Plain(http: HttpClient, rootUrl: string, params: SetMitarbeiterInactive$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<MitarbeiterDto>> {
  const rb = new RequestBuilder(rootUrl, setMitarbeiterInactive$Plain.PATH, 'delete');
  if (params) {
    rb.path('mitarbeiterId', params.mitarbeiterId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MitarbeiterDto>;
    })
  );
}

setMitarbeiterInactive$Plain.PATH = '/v1/mitarbeiter/delete/{mitarbeiterId}';
